// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = 0;

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);//if you change the interval, you have to change the interval set in hornstrup.contourCustom.js (is now set to 251)

function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        if($('#header').hasClass('nav-moving-up')){ $('#header').removeClass('nav-moving-up');}
        if(!$('#header').hasClass('nav-moving')){ $('#header').addClass('nav-moving');}
        if(!$('#header').hasClass('nav-moving-down')){ $('#header').addClass('nav-moving-down');}
        if(!$('body').hasClass('body-scroll')){ $('body').addClass('body-scroll');}
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            if($('#header').hasClass('nav-moving-down')){ $('#header').removeClass('nav-moving-down');}
            if(!$('#header').hasClass('nav-moving')){ $('#header').addClass('nav-moving');}
            if(!$('#header').hasClass('nav-moving-up')){ $('#header').addClass('nav-moving-up');}
        }
        if(!$('body').hasClass('body-scroll')){ $('body').addClass('body-scroll');}
    }
   if($('#header').offset().top == 0){
        if($('body').hasClass('body-scroll')){ $('body').removeClass('body-scroll');}
        if($('#header').hasClass('nav-moving')){ $('#header').removeClass('nav-moving');}
        if($('#header').hasClass('nav-moving-up')){ $('#header').removeClass('nav-moving-up');}
        if($('#header').hasClass('nav-moving-down')){ $('#header').removeClass('nav-moving-down');}
   	}

    lastScrollTop = st;
}




